import { render, staticRenderFns } from "./ConferenceDigital.vue?vue&type=template&id=1d1d0416"
import script from "./ConferenceDigital.vue?vue&type=script&lang=js"
export * from "./ConferenceDigital.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports